<template>
    <div class="home pure-g">
        
        <MainMenu class="pure-u-1-6"/>

        <div class="pure-u-5-6">
    
            <div class="menuBarBox">
                <div class="pure-menu pure-menu-horizontal menuBar">
                    <li id="menuCancel" class="pure-menu-item"><router-link class="pure-menu-link" to="/modules" >Abbrechen</router-link></li>
                    <li id="menuSave" class="pure-menu-item"><a v-on:click="saveAndReturn" class="pure-menu-link" >Speichern</a></li>
                </div>
            </div>
    
            <div class="formBox">
                <form class="pure-form pure-form-stacked">
                    <fieldset>
                        <legend>Modul</legend>

                        <div class="pure-g">
                            <div class="pure-u-1-1">
                                <label for="module">Name</label>
                                <input id="module" class="pure-u-10-24" type="text" v-model="name">
                            </div>

                            <div class="pure-u-1-1">
                                <label for="type">Typ</label>
                                <input id="type" v-model="type" readonly>
                            </div>

                            <div class="pure-u-1 pure-u-md-1-3">
                                <label for="description">Bemerkungen</label>
                                <textarea id="description" class="pure-u-10-24 comment" v-model="description">
                                </textarea>
                            </div>

                            <div class="pure-u-1 pure-u-md-1-3">
                                <label for="configuration">Konfiguration</label>
                                <textarea id="configuration" class="pure-u-10-24 comment" v-model="configuration">
                                </textarea>
                            </div>

                        </div>
                    </fieldset>
                </form>
            </div>
        </div>
    </div>
</template>


<script>
import MainMenu from '@/components/MainMenu.vue'
import axios from "axios"
import router from '@/router.js'
import { getJwt } from '@/utils/auth.js'
import { toastInfo, toastError } from '@/utils/toast.js'
import { getApiUrl } from '@/utils/api.js'


export default {
    name: "editModuleView",
    components: {
        MainMenu
    },
    data: function() {
        return {
            name: null,
            type: null,
            description: null,
            configuration: null
        }
    },
    mounted: function() {

        this.loadData(this.$route.params.url)
    },
    methods: {

        loadData: function(url) {

            axios({
                method: "GET",
                url: url,
                headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + getJwt()
                }
            }).then(
                result => {
                    this.name = result.data.name
                    this.type = result.data.type
                    this.description = result.data.description
                    this.configuration = result.data.configuration
                },
                error => {
                    console.error(error.response.data.status)
                }
      )

        },

        save: function(doReturn) {

            axios({ 
                method: 'PUT', 
                url: this.$route.params.url,
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + getJwt()
                },
                data: {
                    name: this.name,
                    type: this.type,
                    description: this.description,
                    configuration: this.configuration
                }
            })
            .then(
                result => {
                    toastInfo('Die Änderungen wurden gespeichert.')
                    router.push({ name: 'modulesView' })
                },
                error => {
                    toastError(error.response.data.message)
                }
            )
        },
        saveAndReturn: function() {

            this.save(true)
        },
        saveAndNew: function() {

            this.save(false)
        },
        clear: function() {

            this.name = null
            this.comment = null
        }
    }
};
</script>

<style>

#configuration {
    width: 80%;
    height: 500px;
}

</style>
